import PlayButtonInverse from '../../src/legacy/PlayButtonInverse';
export default PlayButtonInverse;
